<template>
  <div>
      <p class="carousel__title carousel__title--multiple">Testimonials</p>
      <div class="carousel__buttons carousel__buttons--centered">
          <button class="button__carouselleft" @click="$refs.myVueperSlidesMultiple.previous()"></button>
          <button class="button__carouselright" @click="$refs.myVueperSlidesMultiple.next()"></button>
      </div>
    <vueper-slides
        class="no-shadow"
        fixedHeight="500px" 
        ref="myVueperSlidesMultiple" 
        :visible-slides="3"
        slide-multiple
        :gap="5"
        :slide-ratio="1 / 4"
        :arrows="false"
        :dragging-distance="200"
        :breakpoints="{ 800: { visibleSlides: 2, slideMultiple: 2 } }">
        <vueper-slide v-for="(slide, i) in getTestimonials" :key="i" :title="'<b>'+slide.name+'</b></br>'+slide.company" :content="slide.content" />
    </vueper-slides>
  </div>
</template>

<script>

import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';
import {mapGetters} from "vuex";

export default {
  components: { VueperSlides, VueperSlide },
  data(){
      return{
       
      }
    },
    computed:{
      ...mapGetters([
        'getTestimonials'
      ])
    }
}
</script>

